export default __webpack_public_path__ + "static/media/2.0cb52793.jpg";